import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import { useYouScreen } from "../YouScreenContext";
import ConnectionsSharing from "../sections/ConnectionsSharing";
import PartnerInviteModal from "../modals/PartnerInviteModal";
import DataSharingModal from "../modals/DataSharingModal";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<YouStackParamList, "ConnectionsDetail">;

export default function ConnectionsDetailScreen({ route }: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const { state, dispatch, partnerInvite } = useYouScreen();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.connections")}
      onBack={handleBack}
      overlay={
        <>
          <PartnerInviteModal
            visible={state.activeModal === "partner-invite"}
            name={state.partnerInviteName}
            phone={state.partnerInvitePhone}
            onChangeName={(name) =>
              dispatch({ type: "SET_PARTNER_INVITE_NAME", name })
            }
            onChangePhone={(phone) =>
              dispatch({ type: "SET_PARTNER_INVITE_PHONE", phone })
            }
            onClose={() => dispatch({ type: "SHOW_MODAL", modal: null })}
            onSend={(name, phone, sharingCategories) =>
              dispatch({
                type: "SEND_PARTNER_INVITE",
                name,
                phone,
                sharingCategories,
              })
            }
            isSending={partnerInvite.isSending}
            sent={partnerInvite.isSuccess}
            isEditing={partnerInvite.isEditing}
            initialSharingCategories={partnerInvite.initialSharingCategories}
            scopeReady={partnerInvite.scopeReady}
            error={partnerInvite.error}
            onDismissError={partnerInvite.resetError}
          />

          <DataSharingModal
            visible={state.dataSharingModal !== null}
            connectionType={state.dataSharingModal}
            connections={state.connections}
            dispatch={dispatch}
            onClose={() =>
              dispatch({
                type: "SHOW_DATA_SHARING_MODAL",
                connectionType: null,
              })
            }
          />
        </>
      }
    >
      <ConnectionsSharing
        connections={state.connections}
        dispatch={dispatch}
        cycleId={route.params?.cycleId}
        initialKind={route.params?.initialKind}
      />
    </YouDetailScreenLayout>
  );
}
